import moment from 'moment';

export const validate = values => {
  const errors = {};
  
  if (!values.rentedOutList || values.rentedOutList.length === 0) {
    errors.rentedOutList = 'At least one rented out period is required';
  } else {
    const rentedOutErrors = [];
    
    values.rentedOutList.forEach((item, index) => {
      const itemErrors = {};
      
      if (!item.dateRange) {
        itemErrors.dateRange = 'Date range is required';
      } else {
        const { startDate, endDate } = item.dateRange;
        
        if (!startDate) {
          itemErrors.dateRange = 'Start date is required';
        } else if (!endDate) {
          itemErrors.dateRange = 'End date is required';
        } else if (!moment.isMoment(startDate) || !moment.isMoment(endDate)) {
          itemErrors.dateRange = 'Invalid date format';
        } else if (startDate.isAfter(endDate)) {
          itemErrors.dateRange = 'Start date cannot be after end date';
        } else if (startDate.isBefore(moment().subtract(1, 'day'))) {
          itemErrors.dateRange = 'Start date cannot be in the past';
        }
      }
      

      if (item.numberOfUnits === undefined || item.numberOfUnits === null || item.numberOfUnits === '') {
        itemErrors.numberOfUnits = 'Number of units is required';
      } else if (isNaN(item.numberOfUnits)) {
        itemErrors.numberOfUnits = 'Number of units must be a number';
      } else if (Number(item.numberOfUnits) < 0) {
        itemErrors.numberOfUnits = 'Number of units cannot be negative';
      } else if (Number(item.numberOfUnits) === 0) {
        itemErrors.numberOfUnits = 'Number of units must be greater than 0';
      }
      
      if (Object.keys(itemErrors).length > 0) {
        rentedOutErrors[index] = itemErrors;
      }
    });
    
    if (rentedOutErrors.length > 0) {
      errors.rentedOutList = rentedOutErrors;
    }
  }
  
  return errors;
};